import React, { Component } from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import debounce from 'lodash-es/debounce';
import isEqual from 'lodash-es/isEqual';
import { Api } from '../utils/api';
import Grid from '@material-ui/core/Grid';
import TablePagination from '@material-ui/core/TablePagination';
import EntityGroupsListTable from './components/entity_groups_list_table.component';
import CircularProgress from '@material-ui/core/CircularProgress';
import { observer } from 'mobx-react';
import ToolsButton from '../components/tools_button.component';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Formik } from 'formik';
import { Typography } from '@material-ui/core';

const rowsPerPage = 30;

const EntityGroupsList = observer(
  
  class EntityGroupsList extends Component {

    constructor() {
      super();
      this.api = new Api();
      this.search = debounce(this.searchInitial.bind(this), 250, { leading: true });
      this.onChange = this.onChange.bind(this);
      this.handleChangePage = this.handleChangePage.bind(this);
      this.advancedChange = this.advancedChange.bind(this);
      this.toggleAdvancedFilter = this.toggleAdvancedFilter.bind(this);
      this.arrayNewGroup = this.arrayNewGroup.bind(this);
      this.createNewGroup = this.createNewGroup.bind(this);
      this.getProfissionalUsers = this.getProfissionalUsers.bind(this);
      this.getEntities = this.getEntities.bind(this);
      this.showAlert = this.showAlert.bind(this);
      this.closeAlert = this.closeAlert.bind(this);
    }

    oldValues = null;

    componentDidMount() {
      let profissional_users = true;
      let with_no_group = true;
      this.search();
      this.getProfissionalUsers(profissional_users);
      this.getEntities(with_no_group);
    }

    state = {
      entities_with_no_group: null,
      add_to_new_group: null,
      profissionalUsers: null,
      showAlert:false,alertTitle:"",alertMessage:""
    };
  

    /** 
     * Search bar 
     */

    searchInitial() {
      const { query, searchValues, page } = this.props.store;
      const params = { search: query, ...searchValues };
      this.api.get('/entity_groups', { ...params, page:page+1,rows:rowsPerPage })
      .then(({ data : { entity_groups, count } }) => {
        this.props.store.setCount(count);
        this.props.store.setEntityGroups(entity_groups);
      });
    }

    handleChangePage(event ,page) {
      this.props.store.setPage(page);
      this.search();
    }

    onChange(event) {
      this.props.store.setQuery(event.target.value);
      this.search();
    }

    toggleAdvancedFilter() {
      this.props.store.toggleAdvancedFilter();
      this.search();
    }

    advancedChange(query) {
      this.props.store.setSearchValues(query);
      this.search();
    }

    /** 
     * Other search components
     */

    handleChange(values) {
      this.findEntities({
        ...values
      });
    }

    findEntities(searchValues, force=false) {
      if (isEqual(searchValues, this.oldValues || {}) && !force) {
        return;
      }
      this.oldValues = searchValues;
      const { page } = this.props.store;

      this.api.get('/entity_groups', {
        ...searchValues,
        page
      })
      .then(({ data : { entity_groups, count } }) => {
        this.props.store.setEntityGroups(entity_groups);
        this.props.store.setCount(count);
      });
    }

    /**
     * 
     */

    //Criar array de entidades a serem adicionadas ao novo grupo
    arrayNewGroup = (event, values) => {
      const oldarray = values;
      const newarray = [];
      for (let i = 0; i < oldarray.length; i++) {
          newarray.push(oldarray[i].id);
      }
        this.setState({
          add_to_new_group: newarray
        });
      }

    //Método para criar um grupo novo
    createNewGroup = async (data) => {
      if(data.group_entities != null && data.superuser_id != null){
        try {
          const res = await this.api.post(`/entity_groups`, {name: data.superuser_name, user_id: data.superuser_id});
          let newGroupId = res.data.id;
          for(let i = 0; i < data.group_entities.length; i++){
            this.api.patch(`/entities/${data.group_entities[i]}`, {group_id: newGroupId});
          }
          this.showAlert("Sucesso", "Grupo criado com sucesso!");
          setTimeout(function(){ window.location.reload(); }, 3000);
        } catch (err) {
          console.log(err);
          this.showAlert("Erro", "Ocorreu um erro ao gravar");
        } 
      }else{
        this.showAlert("Erro", "Por favor preencha os dados em falta");
      } 
    };

    //ir buscar a lista de hi_users (so profissionais e sem grupo associado)
    getProfissionalUsers(profissional_users) {
      this.api.get(`users`, {profissional_users})
      .then(({data = null}) => {
        this.setState({profissionalUsers: data});
      });
    }

    //ir buscar a lista de entidades sem grupo associado
    getEntities(with_no_group) {
      this.api.get(`entities`, {with_no_group})
      .then(({data = null}) => {
        this.setState({entities_with_no_group: data});
      });
    }

    showAlert(title,message) {
      this.setState({showAlert: true});
      this.setState({alertTitle: title});
      this.setState({alertMessage: message});
    };
  
    closeAlert() {
      this.setState({showAlert: false});
    };
    


    render() {
      const { entity_groups } = this.props.store;

      return entity_groups ? 
          this.renderList() : 
          (
              <div>
                  <CircularProgress color="primary" />
              </div>
          );
    }

    renderList(){ 
      
      const { entity_groups, count, page } = this.props.store;

      return (
        <>
        <div class="container-entities-list">
        <ToolsButton showCreateNewEntitiesGroup context_type='NewEntitiesGroup' context_id=""/>

        <div id="new_group_form" class="new_group_form d-none">
          <Typography variant="h6" color="#505e6b" gutterBottom style={{marginBottom:"20px"}}>Criar Novo Grupo</Typography>
            <Formik
              initialValues={{ superuser_id: null, superuser_name: null, group_entities: null }} 
              validateOnChange={true}
              validateOnBlur={true}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  values.group_entities = this.state.add_to_new_group;
                  //console.log(values);
                  this.createNewGroup(values);
                  setSubmitting(false);
                }, 400);
              }}
            >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue, 
              setFieldTouched,
              handleInputChange,
            }) => (
            <form onSubmit={handleSubmit}>
              <div class="row">
                <div class="col-12">
                  <p class="mb-1 font-italic">Escolhe um Super Utilizador</p>
                  {this.state.profissionalUsers != null && (
                  <Autocomplete
                    options={this.state.profissionalUsers}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option) => option.id}
                    onChange={(event, value) => [values.superuser_id = value.id, values.superuser_name = ('Grupo de '+value.name)]} 
                    setFieldValue={setFieldValue}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Utilizadores Profissionais"
                        placeholder=""
                        fullWidth
                      />
                    )}
                  />
                  )}

                  <p class="mt-4 mb-1 font-italic">Adiciona entidades ao novo grupo</p>
                  {this.state.entities_with_no_group != null && (
                  <Autocomplete
                    multiple
                    options={this.state.entities_with_no_group}
                    getOptionLabel={(option) => option.name}
                    onChange={this.arrayNewGroup}
                    name="group_entities"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Entidades"
                        fullWidth
                      />
                    )}
                  />
                  )}

                  <div class="mt-4">
                    <Button type="submit">Submeter</Button>
                  </div>

                </div>
              </div>
            </form>
            )}
            </Formik>
          </div>

          <div class="search_bar_entity_groups">
            <Row>
              <Col xs={1}/>
              <Col md={10}>
                <Form style={{ width: '100%'}}>
                  <Form.Control type="text" placeholder="Pesquisar Grupo" onChange={this.onChange}/>
                </Form>
              </Col>
            </Row>
          </div>

          <div className="ml-4">
            <Typography variant="h6" color="#505e6b" gutterBottom style={{marginBottom:"5px"}}>Listagem de Grupos</Typography>
          </div>
          <EntityGroupsListTable
            entity_groups={entity_groups}
          />
          

          <Grid container >
            <Grid item md={12} >
              <TablePagination className="pagination"
                rowsPerPageOptions={[]}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handleChangePage}
              />
            </Grid>
          </Grid>
        </div>
        </>
      );
    }
  }
);

export default EntityGroupsList;